export default "__VITE_ASSET__DAkI5yU4__"